export enum DropOffsPointType {
  Point = 1,
  Home = 2,
}
